import { observable, action, computed, toJS, autorun } from 'mobx';
import RootStore from '../rootStore';
type TBodyBackgroundType = 'white' | 'default';
interface IFooterNavigationStatus {
  isVisibility: boolean;
}
interface IFooterActiveItemIndex {
  activatedIndex: number;
}

export class LayoutStore {
  public rootStore: RootStore
  @observable public isTopPixed: boolean = false;
  @observable public bodyBackgroundType: TBodyBackgroundType = 'default';
  @observable public footerNavigationStatus:IFooterNavigationStatus = {
    isVisibility: true,
  };
  @observable public footerActiveItemIndex:IFooterActiveItemIndex = {
    activatedIndex: 0,
  };
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action public setBodyBackgroundType(bgType?: TBodyBackgroundType) {
    if (bgType === 'white') {
      this.bodyBackgroundType = 'white';
      return;
    }
    if (bgType === 'default') {
      this.bodyBackgroundType = 'default';
      return;
    }
    this.bodyBackgroundType = 'default';
    return;
  }
  @action public setVisibilityFooterNavigation(isVisibility: boolean) {
    this.footerNavigationStatus.isVisibility = isVisibility;
  }

  @action public setActivatedIndex(index: number) {
    this.footerActiveItemIndex.activatedIndex = index;
  }

  @computed
  get isVisibilityFooterNavigation() {
    const footerNavigationStatus = toJS(this.footerNavigationStatus);
    return footerNavigationStatus.isVisibility;
  }

  @computed
  get activeFooterItemIndex() {
    const index = toJS(this.footerActiveItemIndex);
    return index.activatedIndex;
  }

  @computed
  get bodyClassName() {
    if (this.bodyBackgroundType === 'white') {
      return 'body-wh'
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/stores/layout/index.ts